import * as React from "react";

interface CursorPaginationProps {
  nextCursor: string | null;
  onLoadMore: () => void;
  isLoading?: boolean;
}

export function CursorPagination({
  nextCursor,
  onLoadMore,
  isLoading = false,
}: CursorPaginationProps): React.JSX.Element | null {
  if (!nextCursor) return null;

  return (
    <div className="px-6 pb-8 text-center">
      <button
        type="button"
        onClick={onLoadMore}
        disabled={isLoading}
        className="min-h-[44px] px-8 py-2.5 border border-[var(--border)] rounded-[var(--radius-sm)] bg-[var(--surface)] text-[var(--fg)] text-[13px] font-[600] font-[var(--font)] cursor-pointer transition-colors hover:bg-[var(--surface-2)] hover:border-[rgba(0,0,0,0.18)] disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-2 focus-visible:outline-[var(--accent)] focus-visible:outline-offset-2"
      >
        {isLoading ? "Загрузка..." : "Загрузить ещё"}
      </button>
    </div>
  );
}
